
export default {
  // 模式
  "common.mode.auto": "Saját termelés, saját fogyasztás",
  "common.mode.economy": "Gazdasági mód",
  "common.mode.exigency": "Vészmód",

  // 设备
  "common.grid": "Villamos hálózat",
  "common.evChargers": "Elektromos autó töltőállomások",
  "common.evCharger": "Elektromos autó töltőállomás",
  "common.pv": "Fotovoltaikus (PV)",
  "common.inverter": "Inverter",
  "common.pcs": "Inverter + akkumulátor",
  "common.terminal": "Terminális eszköz",
  "common.airc": "Klíma",
  "common.engine": "Motor",
  "common.battery": "Akkumulátor",
  "common.metter": "Villamossági mérőóra",
  "common.other": "Egyéb",
  "common.power": "Teljesítmény",
  "common.powerTotal": "Összesített teljesítmény",
  "common.voltage": "Feszültség",
  "common.electricity": "Villamosság",
  "common.current": "Áram",
  "common.homeUsage": "Házirendelt teljes fogyasztás",
  "common.battery.power": "Akkumulátor teljesítménye",

  // 数据
  "common.noDataAvailable": "Jelenleg nincs elérhető adat~",
  "common.tips": "Tipp",
  "common.reset": "Alaphelyzetbe állítás",
  "common.currencyUnit": "¥",
  "common.submiting": "Feldolgozás... Kérjük, várjon...",
  "common.close": "Zárás",
  "common.from": "Forrás:",
  "common.useIn": "Használat célja:",
  "common.energyPercent": "Energiafolyam aránya",
  "common.dataFlow": "Adatfolyam",
  "common.getDataIng": "Adatok lekérése folyamatban... Kérjük, várjon...",
  "common.pageLoading": "Oldal tartalma betöltése folyamatban... Kérjük, várjon...",
  "common.reseting": "Oldal tartalma alaphelyzetbe állítása... Kérjük, várjon...",
  "common.save": "Mentés",
  "common.onlyNumberTips": "Csak számok adhatóak meg",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault": "Hiba",
  "common.charge": "Töltés",
  "common.discharge": "Fehérítés",
  "common.buy": "Vásárlás",
  "common.sell": "Eladás",
  "common.loadingInfo": "Betöltés folyamatban... Kérjük, várjon...",

  // 
  "common.moreFeatures": "További funkciók",
  "common.confirm": "Megerősítés",
  "common.saveing": "Mentés folyamatban... Kérjük, várjon...",
  "common.searchPlacholder": "Kérjük, írja be a keresési kulcsszót",
  "common.iSee": "Értem",
  "common.pageErrorTips1": "Hoppá, hiba történt az oldalon~",
  "common.pageErrorTips2": "Próbálja újra betölteni az oldalt vagy lépjen kapcsolatba a támogatással~",
  "common.refresh": "Frissítés",
  "common.backToHome": "Vissza a főoldalra",
  "common.checkTips": "Ellenőrzés folyamatban... Kérjük, várjon...",
  "common.back": "Vissza",
  "common.cancel": "Mégsem",
  "common.optional": "Opcionális",
  "common.required": "Kötelező",
  "common.status": "Állapot",
  "common.statusNoDelete": "Nincs törölve",
  "common.statusDelete": "Törölve",
  "common.submit": "Beküldés",
  "common.disable": "Letiltás",
  "common.enable": "Engedélyezés",
  "common.year": "év",
  "common.month": "hónap",
  "common.day": "nap",
  "common.version": "Verziószám:",
  "common.backHome": " Vissza a főoldalra",
  "common.backHomeSorry": " Sajnáljuk, az oldal elment el véletlenül",
  "common.requestTips1": "Az adatok feldolgozása folyamatban, ne küldjön újra",
  "common.requestTips2": "Rendszerüzenet",
  "common.requestTips3": "A bejelentkezési állapot lejárt, kérjük jelentkezzen be újra",
  "common.requestTips4": "Újraeljelentkezés",
  "common.requestTips5": "Érvénytelen munkamenet vagy a munkamenet lejárt, kérjük jelentkezzen be újra.",
  "common.requestTips6": "Serverhiba, kérjük, próbálja újra később.",
  "common.requestTips7": "A rendszerinterfész kérelem időtúllépés",
  "common.requestTips8": "Rendszerinterfész",
  "common.requestTips9": "Hiba",
  "common.iknow": "Értem",
  "common.logoutSuccess": "Sikeres kijelentkezés",
  
  // 了解更多组件
  "common.knowMore.title": "További információkért lépjen kapcsolatba a Beinengggel",
  "common.knowMore.email": "Kapcsolat e-mail",
  "common.knowMore.phone": "Kapcsolat telefonszáma",
  "common.knowMore.wechat": "Kapcsolat WeChat",
  "common.knowMore.website": "Hivatalos weboldal címe",
  "common.knowMore.address": "Kapcsolat cím",
  "common.knowMore.addressDetail": "1205. és 1301. szoba, 5. épület, 8. Qinghe út, Huangjingkeng, Huangjiang városrész, Dongguan város, Guangdong tartomány",
  
  // 本地连接组件
  "common.localConnection": "Helyi kapcsolat",
  "common.operateInApp": "Az műveletet az alkalmazásban végezze el!",
  
  "common.enbleStaus": "Engedélyezési állapot",
  "common.battery.status": "Nincs töltés és fehérítés",

  "account.forgetThePassword": "Jelszó elfelejtése",
  "account.logInDirectly": "Közvetlen bejelentkezés",
  "account.tips1": "Átirányítás az oldalra folyamatban... Kérjük, várjon...",
  "account.tips2": "Először olvassa el és fogadja el a felhasználói feltételeket!",
  "account.autoLogin": "Automatikus bejelentkezés",
  "account.userLogin": "Felhasználó bejelentkezése",
  "account.registerTips": "Még nincs fiókja? Kattintson ide a regisztrációhoz",
  "account.userEmail": "Felhasználónév / e-mail",
  "account.userEmailTips": "Kérjük, írja be a felhasználónevet vagy az e-mailt",
  "account.password": "Jelszó",
  "account.passwordTips": "Kérjük, írja be a jelszót",
  "account.submit": "Beküldés",
  "account.submitTips": "Beküldés folyamatban... Kérjük, várjon...",
  "account.otherLoginTips": "Vagy válasszon másik bejelentkezési módot",
  "account.userRegistration": "Felhasználó regisztrációja",
  "account.userName": "Felhasználónév",
  "account.userNameTips": "Kérjük, írja be a felhasználónevet",
  "account.emailTips1": "Kérjük, írja be az e-mail címet",
  "account.emailTips2": "Érvénytelen e-mail cím formátum",
  "account.phone": "Telefonszám",
  "account.phoneTips1": "Kérjük, írja be a telefonszámot",
  "account.phoneTips2": "Érvénytelen telefonszám",
  "account.phoneTips3": "Kérjük, írja be a telefonszámot",
  "account.passwordTips1": "Kérjük, írja be a 6-30 karakteres jelszót",
  "account.passwordTips2": "Érvénytelen jelszó formátum: a jelszónak angol betűket, számokat, aláhúzásjeleket, kötőjeleket és pontokat tartalmaznia kell, hosszúsága 6-12 karakter",
  "account.passwordTips3": "A két jelszó nem egyezik, kérjük ellenőrizze és írja be újra!",
  "account.passwordTips4": "Kérjük, írja be a jelszót: a jelszónak angol betűket, számokat, aláhúzásjeleket, kötőjeleket és pontokat tartalmaznia kell",
  "account.passwordTips5": "Jelszó megerősítése",
  "account.passwordTips6": "Kérjük, írja be a jelszó megerősítést",
  "account.passwordTips7": "A két jelszó nem egyezik, kérjük ellenőrizze és írja be újra!",
  "account.passwordTips8": "Kérjük, írja be a jelszó megerősítést",
  "account.passwordTips9": "Gratulálunk, a regisztráció sikeres!",
  "account.passwordTips10": "A felhasználóneve:",
  "account.emailIs": "Az e-mail címe:",
  "account.goToLoginPage": "s másodperc múlva automatikusan átirányít a bejelentkezési oldalra",
  "account.goLogin": "Bejelentkezés",
  "account.goRegister": "Regisztráció",
  "account.loginSuccess": "Sikeres bejelentkezés",
  "account.email": "E-mail",
  "account.sologn": "Szeretettel készítünk egy személyre szabott energiamegoldást számára",
  "account.pleaseAgree": "Elolvastam és elfogadom a",
  "userAgreement.privacyPolicy": "adatvédelmi szabályzatot",

  "account.code": "Ellenőrző kód",
  "account.codeTips": "Kérjük, írja be az ellenőrző kódot",
  "account.codeTips2": "Érvénytelen ellenőrző kód",

    "account.inviteCodeTips": "Kérjük, adja meg a meghívókódot",
    "account.inviteCodeHint": "A meghívókód megszerzéséhez kérjük, lépjen kapcsolatba a telepítővel vagy az üzemeltetési személyzettel",
  "account.modifyPasswordByAccount": "Jelszó módosítása fiók alapján",
  "account.modifyPasswordByEmail": "Jelszó módosítása e-mail alapján",
  "account.getPasswordByAccount": "Jelszó helyreállítása fiók alapján",
  "account.getPasswordByEmail": "Jelszó helyreállítása e-mail alapján",

  "account.sendEmailTips": "Az ellenőrző kód elküldve az e-mailre, kérjük ellenőrizze az e-mailjét",
  "account.name": "Fiók neve",
  "account.newPassword": "Új jelszó",
  "account.confirmNewPassword": "Új jelszó megerősítése",
  "account.nameTips": "Kérjük, írja be a fiók nevét",
  "account.passwordModifySuccess": "Sikeres jelszó módosítás",
  "account.emailCode": "E-mail ellenőrző kód",
  "account.emailCodeTips": "Kérjük, írja be az e-mail ellenőrző kódot",
  "account.emailCodeTips2": "Érvénytelen e-mail ellenőrző kód",
  "account.emailModifySuccess": "Sikeres jelszó módosítás",
  "account.passworTips1": "A jelszó sikeresen visszaállítva!",
  "account.passwordTips11": "Kérjük, írja be a jelszó megerősítést",
  "account.passwordTips12": "Kérjük, írja be az új jelszót",
  "account.nickname": "Felhasználó becenév",
  "account.modifyNickname": "Felhasználó becenév módosítása",
  "account.modifyNicknameSuccess": "Sikeres felhasználó becenév módosítás!",
  "account.nicknameTips": "Kérjük, írja be a felhasználó becenévét",
  "account.nicknameError": "Sikertelen felhasználó becenév módosítás!",

  "account.login": "Bejelentkezés",
  "account.quickRegister": "Gyors regisztráció",
  "account.sendCode": "Kód küldése",
  "account.sendTips": "s másodperc múlva újra küldhető",
  "account.sendEmailIng": "E-mail küldése folyamatban... Kérjük, várjon...",
  "account.emailNotEmpty": "Az e-mail cím nem lehet üres",
  "account.registerAccount": "Fiók regisztrációja",
  "account.registerWelcome": "Üdvözöljük a SusprSafe regisztrációjában",
  "account.usernameLimit": "A felhasználónévnek betűvel kell kezdődnie, és csak betűket, számokat és aláhúzásjeleket tartalmazhat, hosszúsága 5-15 karakter",

  "copyright.desc2": "Weboldal regisztrációs információ: Guangdong ICP regisztráció 2021169764 szám",

  "editUserInfo.editUserInformation": "Felhasználó adatainak szerkesztése",
  "editUserInfo.modifyUsername": "Felhasználó név módosítása",
  "editUserInfo.changePictures": "Profilkép módosítása",
  "editUserInfo.savePicturesSuccess": "A felhasználó profilképe sikeresen mentve",
  "editUserInfo.saveError": "Sikertelen mentés",
  "editUserInfo.pictureLimit": "A kép mérete nem haladhatja meg a 2 MB-t",
  "editUserInfo.uploadPicture": "Profilkép feltöltése",
  "editUserInfo.picturePreview": "Előnézet",
  
  "editUserInfo.bindPhoneNumber": "Telefonszám kötése",
  "editUserInfo.bindEmail": "E-mail kötése",
  "editUserInfo.changePassword": "Jelszó módosítása",

  "editUserInfo.notificationSettings": "Értesítési beállítások",
  "editUserInfo.editAccount": "Felhasználó fiók adatainak szerkesztése",
  "editUserInfo.waitBingting": "Kötés folyamatban... Kérjük, várjon...",
  "editUserInfo.collapse": "Összecsukás",
  "editUserInfo.modifyBinding": "Kötés módosítása",
  
  "editUserInfo.emailAddress": "E-mail cím",
  "editUserInfo.tips1": "Sikeres e-mail kötés",
  "editUserInfo.tips2": "Sikertelen mentés",
  "editUserInfo.tips3": "E-mail ellenőrző kód küldése folyamatban... Kérjük, várjon...",
  "editUserInfo.tips4": "Az ellenőrző kód elküldve az xxxx e-mailre, kérjük ellenőrizze",
  "editUserInfo.tips5": "Sikertelen ellenőrző kód küldés!",
  "editUserInfo.tips6": "A telefonszám már kötve van",
  "editUserInfo.tips7": "Az e-mail már kötve van",
  "editUserInfo.emailTips1": "Kérjük, írja be az e-mail címet",
  "editUserInfo.emailTips2": "Érvénytelen e-mail cím formátum",
  "editUserInfo.emailTips3": "xxxx másodperc múlva újra küldhető",
  "editUserInfo.emailTips4": "Kód küldése",
  "editUserInfo.emailTips5": "Az e-mail ellenőrző kód nem lehet üres",
  "editUserInfo.emailTips6": "Érvénytelen e-mail ellenőrző kód",
  "editUserInfo.emailCode": "E-mail ellenőrző kód",
  "editUserInfo.save": "Mentés",

  "editUserInfo.phoneTips1": "Sikeres telefonszám kötés",
  "editUserInfo.phoneTips2": "SMS ellenőrző kód küldése folyamatban... Kérjük, várjon...",
  "editUserInfo.phoneTips3": "Az SMS ellenőrző kód elküldve az xxxx telefonszámra, kérjük ellenőrizze",
  "editUserInfo.phoneTips4": "Sikertelen SMS ellenőrző kód küldés!",
  "editUserInfo.phoneTips5": "Kérjük, írja be a telefonszámot",
  "editUserInfo.phoneTips6": "Érvénytelen telefonszám formátum",
  "editUserInfo.phoneTips7": "SMS Kód küldése",
  "editUserInfo.phoneTips8": "SMS ellenőrző kód",
  "editUserInfo.phoneTips9": "Az SMS ellenőrző kód nem lehet üres",
  "editUserInfo.phoneTips10": "Érvénytelen SMS ellenőrző kód",
  "editUserInfo.phone": "Telefonszám",


  "editUserInfo.noticeTips1": "Sikertelen értesítési beállítások lekérése!",
  "editUserInfo.noticeTips2": "Az értesítési beállítások sikeresen mentve!",
  "editUserInfo.noticeTips3": "Alacsony akkumulátor szintű értesítés",
  "editUserInfo.noticeTips4": "Töltőállomás teljes töltés értesítése",
  "editUserInfo.errorNotification": "Hiba értesítés",
  "editUserInfo.updateNotification": "Frissítés értesítés",
  "editUserInfo.monthlyStatisticsNotification": "Havi statisztika értesítés",
  "editUserInfo.notificationMethod": "Fogadási mód",

  "editUserInfo.userNameTips1": "A felhasználó név sikeresen mentve",
  "editUserInfo.userNameTips2": "Sikertelen felhasználó név mentés",
  "editUserInfo.userNameTips3": "Kérjük, írja be a felhasználó nevet",
  "editUserInfo.userNameTips4": "Érvénytelen felhasználó név formátum: csak számokat, aláhúzásjeleket és angol betűket tartalmazhat",
  "editUserInfo.userNameTips5": "Kérjük, írja be a felhasználó nevet",
  "editUserInfo.userNameTips6": "Mentés folyamatban... Kérjük, várjon...",
  "editUserInfo.userName": "Felhasználó név",

  "editUserInfo.avatorTips": "Kattintson a profilkép módosításához",
  "editUserInfo.verifyCodeTips1": "Kérjük, írja be a megkapott ellenőrző kódot:",
  "editUserInfo.verifyCodeTips2": "A fiók biztonsága érdekében kattintson az alábbi gombra az ellenőrző kód küldéséhez az eredeti telefonszámra:",
  "editUserInfo.verifyCodeTips3": "Kód küldése",
  "editUserInfo.verifyCodeTips4": "Az eredeti telefon ellenőrzése sikeres, kérjük írja be az új kötött telefonszámot",
  "editUserInfo.verifyCodeTips5": "A fiók biztonsága érdekében kattintson az alábbi gombra az ellenőrző kód küldéséhez az eredeti e-mailre:",
  "editUserInfo.verifyCodeTips6": "Az eredeti e-mail ellenőrzése sikeres, kérjük írja be az új e-mailt",
  "editUserInfo.verifyCodeTips7": "Régi jelszó",
  "editUserInfo.verifyCodeTips8": "Először kösse össze az e-mailt!",
  "editUserInfo.verifyCodeTips9": "Az ellenőrző kód elküldve az e-mailre, kérjük ellenőrizze az e-mailjét",
  "editUserInfo.verifyCodeTips10": ", automatikusan átirányít a bejelentkezési oldalra",

  "hems.notice.title": "Értesítés címe", 
  "hems.notice.content": "Értesítés tartalma", 
  "hems.notice.operate": "Művelet",
  "hems.notice.noRead": "Olvasatlan",
  "hems.notice.read": "Olvasott",
  "hems.notice.warning": "Figyelmeztetés",
  "hems.notice.error": "Hiba",
  "hems.notice.success": "Statisztikai kiegyenlítés",
  "hems.notice.sys": "Rendszerinformáció",
  "hems.notice.operateSuccess": "Sikeres művelet",
  "hems.notice.operateTips": "Válassza ki a művelet céljául szolgáló elemet",

  // 首页
  "hems.home.selfuseRate": "Saját termelés, saját fogyasztás aránya",
  "hems.home.percent": "Százalék",
  "hems.home.todayData": "Mai adatok",
  "hems.home.todayPowerGeneration": "Mai energia termelés",
  "hems.home.salesIncome": "Energia eladás bevétel",
  "hems.home.saved": "Megspórolt összeg:",
  "hems.home.reduce": "Szénlábnyom csökkentés",
  "hems.home.tips1": "Jelenleg nincs adat, még nem kötötte össze az xxxx-et",
  "hems.home.criticalLoad": "Kritikus terhelés",
  "hems.home.keyVoltage": "Kritikus feszültség",
  "hems.home.householdLoad": "Házirendelt terhelés",
  "hems.home.householdVoltage": "Házirendelt feszültség",
  "hems.home.generalLoad": "Általános terhelés",
  "hems.home.generalVoltage": "Általános feszültség",
  "hems.home.batteryHealth": "Akkumulátor állapota",
  "hems.home.averageTemp": "Átlaghőmérséklet",
  "hems.home.gridLoad": "Villamos hálózat terhelés",
  "hems.home.toggeleDataSource": "Az aktuálisan megjelenített adatok átváltva:",
  "hems.home.toggleTips": "Biztosan szeretné váltani?",
  "hems.home.modeSending": "Mód parancs küldése folyamatban... Kérjük, várjon...",
  "hems.home.modeSuccess": "A mód váltási parancs sikeresen elküldve!",
  "hems.home.isOnline": "Online állapot",
  "hems.home.useStatus": "Használati állapot",
  "hems.home.workModeText": "Aktuális működési mód:",
  "hems.home.toggleDataSourceText": "Az aktuálisan megjelenített adatok átváltva:",
  "hems.ev.charge.status": "Töltési állapot",
  "hems.ev.charge.time": "Töltési idő",
  "hems.ev.charge.count": "Valós idejű töltött energia",
  "hems.ev.charge.status.empty": "Frei",
  "hems.ev.charge.status.ing": "Csatlakozva és töltés folyamatban",
  "hems.ev.charge.status.null": "Csatlakozva, de nincs töltés",
  "hems.ev.charge.status.error": "Hiba",
  "hems.hour": "óra",
  "hems.minue": "perc",
  "hems.ev.chagre.number": "Töltőállomás szám",

  // User Guide
  "hems.userGuide.selfUse": "Saját termelés, saját fogyasztás",
  "hems.userGuide.selfUseTips": "Előnyben részesíti a fotovoltaikus energiát, hiányzó részét a villamos hálózat tamamítja",
  "hems.userGuide.economyMode": "Gazdasági mód",
  "hems.userGuide.economyModeTips": "Az energiafelhasználási stratégia optimalizálása az ár alapján",
  "hems.userGuide.emergencyMode": "Vészmód",
  "hems.userGuide.emergencyModeTips": "Előnyben részesíti a kritikus terhelés energiaellátását",

  // 图表页面
  "hems.history.energyStatistics": "Energia statisztika",
  "hems.history.revenueStatistics": "Bevétel statisztika",
  "hems.history.greenStatistics": "Zöld kibocsátás csökkentés",
  "hems.history.revenueTitle": "Összes energia eladás bevétel",
  "hems.history.savingsTitle": "Összes spórolt összeg",
  "hems.history.carbonTitle": "Összes szénkibocsátás csökkentés",
  "hems.history.day": "nap",
  "hems.history.month": "hónap",
  "hems.history.year": "év",
  "hems.history.beforeDay": "Előző nap",
  "hems.history.afterDay": "Következő nap",
  "hems.history.beforeMonth": "Előző hónap",
  "hems.history.afterMonth": "Következő hónap",
  "hems.history.beforeYear": "Előző év",
  "hems.history.afterYear": "Következő év",
  "hems.history.totalUse": "Összes fogyasztás",
  "hems.history.fullScreen": "Teljes képernyő",
  "hems.history.timeSelect": "Dátum kiválasztása",
  "sync.tips1": "Az adat szinkronizációs parancs sikeresen elküldve!",
  "sync.tips2": "Az adat szinkronizáció folyamatban, az adatmennyiség miatt időre van szükség, kérjük ellenőrizze újra fél óra múlva~",
  "sync.tips3": "Az eszköz adat szinkronizációja késleltetést okozhat, ha adat eltéréseket talál, kattintson erre:",
  "sync.tips4": "Adatok szinkronizálása",

  "charge.info": "Töltőállomás információk",
  "news.loading": "Betöltés folyamatban...",
  "news.noMore": "Nincs több adat",
  "hems.pv.power": "Fotovoltaikus energia mennyiség",

  // UEH specific
  "ueh.sellPower": "Eladott energia mennyiség",
  
  "menu.home": "Főoldal",
  "menu.history": "Történeti adatok",
  "menu.device": "Eszközök",
  "menu.settings": "Beállítások",
  "menu.messageCenter": "Üzenetközpont",
  "menu.help": "Segítség és támogatás",
  "menu.mine": "Saját adatok",


  "mine.userSetting": "Felhasználó beállítások",
  "mine.terminalSetting": "Terminális alapbeállítások",
  "mine.uploadCloud": "Adatok felhőbe mentése",
  "mine.changeVersion": "Frissítés ellenőrzése",
  "mine.language": "Nyelv váltása",
  "mine.about": "Rólunk",
  "mine.feedback": "Visszajelzés",
  "mine.logout": "Kijelentkezés",
  "mine.logoutAccount": "Fiók törlése",

  "mine.logoutAccountTips": "[ ] nevű fiók törlése",
  "mine.logoutAccountTips1": "[ ]hoz kötött fiók törlése",
  "mine.logoutAccountCare": "Fiók törlési kérelem kapcsolatos megjegyzések:",
  "mine.logoutAccountCare1": "1. A fiók biztonságos állapotban van",
  "mine.logoutAccountCare1-1": "A fiók normál használati állapotban van, nincsenek ellopási, szabálytalansági vagy tiltási kockázatok.",
  "mine.logoutAccountCare2": "2. A fiók engedélyei és kötései megszüntetve",
  "mine.logoutAccountCare2-1": "A fiók összes harmadik féltől származó engedélye megszüntetve.",
  "mine.logoutAccountCare3": "3. A fiók törlése után nem állítható vissza, a felhasználó adatai törlődnek",
  "mine.logoutAccountCare3-1": "A fiók törlése után a kötött telefonszám, e-mail és egyéb adatok törlődnek és nem állíthatók vissza.",
  "mine.confirmLogout": "Törlés megerősítése",
  "mine.logoutSuccess": "A fiók sikeresen törölve!",


  "mine.feedbackIssues": "Probléma visszajelzés",
  "mine.feedQuantity": "Mennyiség",
  "mine.feedAmount": "Maximális 9 kép, maximális méret 1 MB/kép",

  "mine.notice.fail": "Sikertelen értesítési beállítások lekérése!",
  "mine.notice.saveSuccess": "Az értesítési beállítások sikeresen mentve!",
  "mine.notice.saveFail": "Sikertelen mentés!",
  "mine.notice.title": "Értesítési beállítások",
  "mine.notice.batteryLow": "Alacsony akkumulátor szintű értesítés",
  "mine.notice.chargingFinish": "Töltőállomás teljes töltés értesítése",
  "mine.notice.error": "Hiba értesítés",
  "mine.notice.update": "Frissítés értesítés",
  "mine.notice.monthly": "Havi statisztika értesítés",
  "mine.notice.receiveType": "Fogadási mód",

  "mine.language.welcome": "Üdvözöljük a SusprSafe-ben",
  "mine.language.desc1": "Kérjük válassza a nyelv változót a tartózkodási helye alapján",
  "mine.language.desc2": "Minden időpontban módosítható az alkalmazás beállításaiban",

  "mine.userInfo.avatar": "Profilkép",
  "mine.userInfo.nickname": "Becenév",
  "mine.userInfo.password": "Jelszó",
  "mine.userInfo.changePassword": "Jelszó módosítása",
  "mine.userInfo.setPassword": "Jelszó beállítása",
  "mine.userInfo.phoneNumber": "Telefonszám",
  "mine.userInfo.bindPhone": "Telefonszám kötése",
  "mine.userInfo.bindEmail": "E-mail kötése",
  "mine.loginExpired": "A bejelentkezési állapot lejárt, kérjük jelentkezzen be újra",
  "mine.userInfo.title": "Felhasználó adatok",
  "mine.userInfo.bind": "Kötés",
  "mine.userInfo.modify": "Módosítás",
  "mine.userInfo.modifyNickname": "Becenév módosítása",
  "mine.userInfo.userNickname": "Felhasználó becenév",
  "mine.userInfo.selectPic": "Kérjük válassza ki a feltöltendő képet",
  "mine.userInfo.saveSuccess": "Sikeres mentés",
  "mine.userInfo.uploadFail": "Sikertelen feltöltés",
  "mine.userInfo.avatarSaveSuccess": "A profilkép sikeresen mentve",
  "mine.userInfo.nameTips1": "A felhasználó becenév nem lehet üres",
  "mine.userInfo.nameTips2": "Kérjük, írja be a felhasználó becenévét",

  "common.pleaseSelect": "Kérjük válasszon",
  "question.commonQuestions": "Gyakori kérdések",
  "account.toggleLanguage": "Nyelv váltása",
  "account.localConnection": "Helyi kapcsolat",
  "account.selectLanguage": "Kérjük válassza a nyelvet",
  "account.sendEmailToast": "Az ellenőrző kód elküldve az xxx e-mailre, kérjük ellenőrizze az e-mailjét",
  "account.emailError": "Érvénytelen e-mail formátum",
  "account.sendEmailFail": "Sikertelen küldés, kérjük próbálja újra",
  
  "common.submitting": "Feldolgozás... Kérjük, várjon...",

  "device.page.noData": "Jelenleg nincs adat, ezt az oldalt csak az alkalmazásban tekintheti meg"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};